import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Excel icon — spreadsheet page with an "X" watermark.
 * Grey shapes use `currentColor` so the parent `.bombiix-icon-container` modifier
 * drives the tint; the inner "X" strokes stay white so the Excel identity mark
 * remains readable regardless of the container colour.
 */
const ExcelIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...rest}
  >
    <rect x="3" y="9" width="6" height="6" rx="1.2" fill="currentColor" />
    <rect x="12.25" y="10" width="2" height="1" rx="0.25" fill="currentColor" />
    <rect x="12.25" y="11.5" width="2" height="1" rx="0.25" fill="currentColor" />
    <rect x="12.25" y="13" width="2" height="1" rx="0.25" fill="currentColor" />
    <rect x="9.75" y="10" width="2" height="1" rx="0.25" fill="currentColor" />
    <rect x="9.75" y="11.5" width="2" height="1" rx="0.25" fill="currentColor" />
    <rect x="9.75" y="13" width="2" height="1" rx="0.25" fill="currentColor" />
    <path
      d="M11.167 7.50098H14.127L11.167 4.54102V7.50098ZM15.834 15.334C15.834 15.8201 15.6405 16.2861 15.2969 16.6299C14.9531 16.9737 14.4862 17.167 14 17.167H6C5.51389 17.1669 5.04784 16.9736 4.7041 16.6299C4.36039 16.2861 4.16699 15.8201 4.16699 15.334V4.66699C4.16708 4.18088 4.36036 3.71483 4.7041 3.37109C5.04784 3.02735 5.51389 2.83407 6 2.83398H10.667C10.7996 2.83398 10.9267 2.8867 11.0205 2.98047L15.6875 7.64746C15.7811 7.7412 15.834 7.86852 15.834 8.00098V15.334ZM5.16699 15.334C5.16699 15.5549 5.25495 15.7666 5.41113 15.9229C5.56734 16.0791 5.7791 16.1669 6 16.167H14C14.221 16.167 14.4336 16.0791 14.5898 15.9229C14.7459 15.7666 14.834 15.5548 14.834 15.334V8.50098H10.667C10.391 8.50098 10.1672 8.27697 10.167 8.00098V3.83398H6C5.7791 3.83407 5.56734 3.92192 5.41113 4.07812C5.25493 4.23433 5.16708 4.4461 5.16699 4.66699V15.334Z"
      fill="currentColor"
    />
    <path d="M7.8002 13.7992H6.89113L4.2002 10.1992H5.12756L7.8002 13.7992Z" fill="white" />
    <path d="M4.2002 13.7992H5.10926L7.8002 10.1992H6.87283L4.2002 13.7992Z" fill="white" />
  </svg>
);

export default ExcelIcon;
